/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Student_Feature_2Inputs */

const en_settings_student_feature_2 = /** @type {(inputs: Settings_Student_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 AI actions/month`)
};

const de_settings_student_feature_2 = /** @type {(inputs: Settings_Student_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 KI-Aktionen/Monat`)
};

const fr_settings_student_feature_2 = /** @type {(inputs: Settings_Student_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 actions IA/mois`)
};

const es_settings_student_feature_2 = /** @type {(inputs: Settings_Student_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 Acciones IA/mes`)
};

const it_settings_student_feature_2 = /** @type {(inputs: Settings_Student_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 azioni AI/mese`)
};

const nl_settings_student_feature_2 = /** @type {(inputs: Settings_Student_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 AI-acties/maand`)
};

const pl_settings_student_feature_2 = /** @type {(inputs: Settings_Student_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 akcji AI/miesiąc`)
};

const fi_settings_student_feature_2 = /** @type {(inputs: Settings_Student_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 AI-toimet/kuukausi`)
};

const da_settings_student_feature_2 = /** @type {(inputs: Settings_Student_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 AI-handlinger/måned`)
};

const sv_settings_student_feature_2 = /** @type {(inputs: Settings_Student_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 AI-aktioner/månad`)
};

/**
* | output |
* | --- |
* | "100 AI actions/month" |
*
* @param {Settings_Student_Feature_2Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_student_feature_2 = /** @type {((inputs?: Settings_Student_Feature_2Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Student_Feature_2Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_student_feature_2(inputs)
	if (locale === "fr") return fr_settings_student_feature_2(inputs)
	if (locale === "es") return es_settings_student_feature_2(inputs)
	if (locale === "it") return it_settings_student_feature_2(inputs)
	if (locale === "nl") return nl_settings_student_feature_2(inputs)
	if (locale === "pl") return pl_settings_student_feature_2(inputs)
	if (locale === "fi") return fi_settings_student_feature_2(inputs)
	if (locale === "da") return da_settings_student_feature_2(inputs)
	if (locale === "sv") return sv_settings_student_feature_2(inputs)
	return en_settings_student_feature_2(inputs)
});